import { useCallback } from 'react';
import { StringParam, NumberParam, useQueryParams } from 'use-query-params';

import { useCard } from 'hooks/use-card';

import { CARD_VIEWER_QUERY_PARAMS } from './constants';

const QueryParamConfig = {
  nav: StringParam,
  [CARD_VIEWER_QUERY_PARAMS.VIEW_CARD]: NumberParam,
  [CARD_VIEWER_QUERY_PARAMS.RANK]: NumberParam,
  [CARD_VIEWER_QUERY_PARAMS.SECTION]: StringParam,
};

export default function useCardViewer() {
  const [
    {
      [CARD_VIEWER_QUERY_PARAMS.VIEW_CARD]: currentCardId,
      [CARD_VIEWER_QUERY_PARAMS.RANK]: currentCardRank,
    },
    setQuery,
  ] = useQueryParams(QueryParamConfig);

  const { card, profile, loadCard, failed } = useCard(
    currentCardId ? String(currentCardId) : undefined,
  );

  const open = useCallback(
    (
      cardId: number,
      options?: {
        rank?: number | null;
        scrollToSources?: boolean;
      },
    ) => {
      const sourceParam = options?.scrollToSources
        ? { [CARD_VIEWER_QUERY_PARAMS.SECTION]: 'sources' }
        : {};

      setQuery({
        [CARD_VIEWER_QUERY_PARAMS.VIEW_CARD]: cardId,
        [CARD_VIEWER_QUERY_PARAMS.RANK]: options?.rank,
        ...sourceParam,
      });
    },
    [setQuery],
  );

  const close = useCallback(() => {
    setQuery({
      [CARD_VIEWER_QUERY_PARAMS.VIEW_CARD]: undefined,
      [CARD_VIEWER_QUERY_PARAMS.RANK]: undefined,
      [CARD_VIEWER_QUERY_PARAMS.SECTION]: undefined,
    });
  }, [setQuery]);

  return {
    currentCardId,
    targetCard: card,
    targetProfile: profile,
    close,
    open,
    failed,
    loadCard,
    currentCardRank,
  };
}
